/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCustomQuestionMutationVariables = Types.Exact<{
  name: Types.Scalars['String'];
  choices?: Types.InputMaybe<Array<Types.Scalars['String']> | Types.Scalars['String']>;
  type?: Types.InputMaybe<Types.QuestionType>;
}>;


export type CreateCustomQuestionMutation = { createCustomQuestion?: { id: number, isUsed: boolean, name: string, choices: Array<{ id: number, name: string, satisfaction_value: number }> } | undefined };


export const CreateCustomQuestionDocument = gql`
    mutation CreateCustomQuestion($name: String!, $choices: [String!], $type: QuestionType) {
  createCustomQuestion(name: $name, choices: $choices, type: $type) {
    id
    isUsed
    name
    choices {
      id
      name
      satisfaction_value
    }
  }
}
    `;

/**
 * __useCreateCustomQuestionMutation__
 *
 * To run a mutation, you first call `useCreateCustomQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomQuestionMutation, { data, loading, error }] = useCreateCustomQuestionMutation({
 *   variables: {
 *      name: // value for 'name'
 *      choices: // value for 'choices'
 *      type: // value for 'type'
 *   },
 * });
 */
export function useCreateCustomQuestionMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomQuestionMutation, CreateCustomQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomQuestionMutation, CreateCustomQuestionMutationVariables>(CreateCustomQuestionDocument, options);
      }
export type CreateCustomQuestionMutationHookResult = ReturnType<typeof useCreateCustomQuestionMutation>;
export type CreateCustomQuestionMutationResult = Apollo.MutationResult<CreateCustomQuestionMutation>;
export type CreateCustomQuestionMutationOptions = Apollo.BaseMutationOptions<CreateCustomQuestionMutation, CreateCustomQuestionMutationVariables>;